import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle as MuiDialogTitle,
  Tooltip,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import styled from "styled-components";
import {
  formatBoolean,
  formatCurrency,
  formatDate,
} from "../../../../../../../../utils/formatters";

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
`;

const StyledCell = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const baseColumn = {
  renderCell: ({ formattedValue }) => (
    <Tooltip title={formattedValue || ""}>
      <StyledCell>{formattedValue}</StyledCell>
    </Tooltip>
  ),
};

const enumColum = {
  ...baseColumn,
  valueFormatter: ({ value }) => value?.replace("_", " ")?.toUpperCase(),
};

const columns = [
  {
    ...baseColumn,
    field: "dataInscricao",
    headerName: "Data inscrição",
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    ...enumColum,
    field: "entidadeResponsavel",
    headerName: "Entidade responsável",
  },
  {
    ...baseColumn,
    field: "indicadorAjuizado",
    headerName: "Indicador ajuizado",
    valueFormatter: ({ value }) => formatBoolean(value),
  },
  {
    ...baseColumn,
    field: "numeroInscricao",
    headerName: "Número inscrição",
  },
  {
    ...enumColum,
    field: "receitaPrincipal",
    headerName: "Receita principal",
  },
  {
    ...enumColum,
    field: "situacaoInscricao",
    headerName: "Situação Inscrição",
  },
  {
    ...enumColum,
    field: "tipoCredito",
    headerName: "Tipo crédito",
  },
  {
    ...enumColum,
    field: "tipoSituacaoInscricao",
    headerName: "Tipo situação inscrição",
  },
  {
    ...baseColumn,
    field: "ufUnidadeResponsavel",
    headerName: "UF unidade responsável",
  },
  {
    ...baseColumn,
    field: "unidadeInscricao",
    headerName: "Unidade inscrição",
  },
  {
    ...baseColumn,
    field: "unidadeResponsavel",
    headerName: "Unidade responsável",
  },
  {
    ...baseColumn,
    field: "valorConsolidadoCents",
    headerName: "Valor consolidado",
    valueFormatter: ({ value }) => formatCurrency(value),
  },
];

const DialogTitle = ({ onClose, children, ...props }) => (
  <MuiDialogTitle disableTypography {...props}>
    <Typography variant="h6">{children}</Typography>

    {onClose && (
      <CloseButton onClick={onClose}>
        <CloseIcon />
      </CloseButton>
    )}
  </MuiDialogTitle>
);

const DividasAtivasModal = ({ data, onClose }) => {
  return (
    <Dialog open={!!data} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle onClose={onClose}>Dívidas ativas</DialogTitle>

      <DialogContent>
        <DataGrid
          rows={data || []}
          columns={columns}
          autoHeight
          disableColumnMenu
          disableSelectionOnClick
        />
      </DialogContent>
    </Dialog>
  );
};

export default DividasAtivasModal;
